import Modal from "components/common/Modal";
import styled from "styled-components";

const BlockModal = styled(Modal)`
  box-shadow: ${({ theme }) => theme.shadows.small};

  /* controls padding around the up/down arrow on number fields */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    margin-left: 4px;
  }
`;

export default BlockModal;
